'use client';
import { isOnFullScreenPath } from '@baseball-near-you/common';
import { Separator, cn } from '@baseball-near-you/ui';
import { PATHS } from '@bb/lib/constants';
import type { Route } from 'next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Branding } from './Branding';
import { Container } from './Container';
import { PageTab, type TabProps } from './PageTab';
import { ProfileButton } from './ProfileButton';

export const tabs: TabProps[] = [
  { label: 'Find teams', path: PATHS.Teams as Route },
  {
    label: 'Gear',
    path: PATHS.Gear as Route,
  },
  { label: 'Blog', path: PATHS.Blog as Route },
  // college
];

export function Navbar() {
  const pathname = usePathname();
  // const [isOpen, setIsOpen] = useState(
  //   isServer ? false : !Number(localStorage.getItem(siteNoticeLocalStorageKey))
  // );

  return isOnFullScreenPath(pathname) ? null : (
    <>
      <div
        className={cn(
          'h-[5rem] w-full bg-white'
          // isOpen ? 'h-[7rem]' : 'h-[5rem]'
        )}
      />
      <div className="fixed top-0 z-50 flex w-full flex-col">
        {/* <SiteNotice isOpen={isOpen} setIsOpen={setIsOpen} /> */}
        <div className="flex h-[5rem] w-full justify-center bg-white">
          <Container className="mt-0! w-full max-w-full! bg-white">
            <div className="box-border flex h-full w-full items-center justify-between border-gray-200 border-b bg-white py-5">
              <div className="flex items-center space-x-8">
                <Link href={'/'}>
                  <div className="w-full hover:cursor-pointer">
                    <Branding />
                  </div>
                </Link>
                <Separator
                  orientation="vertical"
                  className="h-full min-h-full"
                />
                <div className="hidden space-x-8 md:flex">
                  {tabs.map((tab) => (
                    <PageTab
                      label={tab.label}
                      path={tab.path}
                      key={tab.label}
                    />
                  ))}
                </div>
              </div>
              <ProfileButton />
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
